import axios from 'axios';
import Instance from './interceptor';
import { API } from '../constants/Constants';
import Toast from '../components/pages/utils/Toast';

export const inviteMember = async (email, expiryTime) => {
  try {
    const response = await Instance.post(`${API.INVITE_USER}`, {
      email,
      expiryTime,
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const inviteAdminOrMember = async (email, role, expiryTime) => {
  try {
    const response = await Instance.post(`${API.INVITE_USER}`, {
      email,
      role,
      expiryTime,
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const resendInviteAdminOrMember = async (email) => {
  try {
    return await Instance.post(`${API.INVITE_USER}`, {
      email,
    });
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const addUser = async ({
  firstName,
  lastName,
  phoneNo,
  password,
  confirmPassword,
  country,
  id,
  token,
}) => {
  try {
    const response = await axios.post(`${API.ADD_USER}`, {
      first_name: firstName,
      last_name: lastName,
      phone_no: phoneNo,
      password,
      confirm_password: confirmPassword,
      country,
      id,
      token,
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response;
    }
  } catch (error) {
    Toast({
      message: `${error?.response?.data?.errorMessage}`,
      variant: 'error',
    });
  }
};

export const verifyToken = async (token) => {
  try {
    return await axios.get(`${API.VERIFY_TOKEN}/${token}`);
  } catch (error) {
    if (error?.response?.data?.errorMessage) {
      Toast({
        message: `${error?.response?.data?.errorMessage}`,
        variant: 'error',
      });
    }
  }
};

export const getCountries = async () => {
  try {
    const response = await axios.get(`${API.GET_COUNTRIES}`);
    return response?.data;
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
    }
  }
};
